export default "__VITE_ASSET__D0fHe0Zy__"